export const TRANSLATION_KEYS = {
  ELEMENTS: "elementTranslations",
  REGIONAL_OFFICE: "regionalOfficeTranslations",
  COUNTRY: "countryTranslation",
  NEWS: "newsTranslation",
  CATEGORY:"categoryTranslation"

};
